export default "__VITE_ASSET__BthtVGX9__"